import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import * as mainNavigation from '../modules/MainNavigation';
import * as frameCollection from '../modules/FrameCollection';
import AppHistory from '../utils/AppHistory';

const reducer = combineReducers(
    {
        [ mainNavigation.constants.STATE_MAIN_NAVIGATION ]: mainNavigation.reducer,
        [ frameCollection.constants.STATE_FRAME_COLLECTION ]: frameCollection.reducer,
        router: connectRouter( AppHistory )
    } );

export default reducer;
